import { Flex, InlineList, Text } from "@instructure/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import styled from "styled-components";
import {
  ERROR,
  useNotification,
} from "../../components/CustomHooks/NotificationProvider";
import { CourseService } from "../../services/CourseService";

const NavLink = styled(Link)`
  border: 0;
  background-color: transparent;
  color: #fff;
  cursor: pointer;
  display: block;
  text-decoration: none;
  &:hover {
    background-color: #27323b;
  }

  &.active {
    background-color: transparent;
    color: #27323b;
  }
  &[role="link"]:focus {
    border: 1px solid #fff;
    border-radius: 2px;
    background-color: #27323b;
    &.active {
      background-color: transparent;
      color: #27323b;
      border: 1px solid #27323b;
    }
  }
`;

const OutcomesLink = ({ reload, setReload, subject, searchTrigger }) => {
  const { t } = useTranslation();
  const showNotification = useNotification();
  const [qualityCalculated, setQualityCalculated] = useState(false);
  const [highQualPercentage, setHighQualPercentage] = useState(0);
  const [unapprovedCount, setUnapprovedCount] = useState(0);
  const [prevSubject, setPrevSubject] = useState("");

  useEffect(() => {
    if ((reload || searchTrigger) && subject && subject !== prevSubject) {
      setQualityCalculated(false);
      setPrevSubject(subject);

      // don't need role control as PCs subject selection via filter is already role-limited
      CourseService.getQualityMetrics(subject)
        .then((quality) => {
          setUnapprovedCount(quality.unapproved);
          setHighQualPercentage(quality.quality_percentage);
        })
        .catch((error) => {
          showNotification(
            `${t("notifications.dashboard.qualityCalculationError")}: ${
              error.statusText
            }`,
            ERROR
          );
        })
        .finally(() => {
          setQualityCalculated(true);
          setReload(false);
        });
    }
  }, [searchTrigger, reload, subject, showNotification]);

  return (
    <Flex wrap="wrap" justifyItems="end">
      <Flex.Item>
        {qualityCalculated && (
          <NavLink role="link" to="/analyze" className="active">
            <InlineList delimiter="pipe">
              <InlineList.Item>
                <Text weight="bold">
                  {`${prevSubject} ${t("dashboard.outcomeQuality")}: `}
                  {Math.ceil(highQualPercentage) + "%"}
                </Text>
              </InlineList.Item>
              <InlineList.Item>
                <Text weight="bold">
                  {t("dashboard.unapprovedOutcomes")}: {unapprovedCount}
                </Text>
              </InlineList.Item>
            </InlineList>
          </NavLink>
        )}
      </Flex.Item>
    </Flex>
  );
};

export default OutcomesLink;
